import type { JSX } from 'react';

import { iconCampaign, iconGroups, iconSend } from '@change-corgi/design-system-legacy/icons';

type SvgComponent = {
	(props: React.SVGProps<SVGSVGElement>): JSX.Element;
	displayName: string;
};

type BulletPoint = {
	icon: SvgComponent;
	text: string;
};

export const BULLET_POINT_ICONS: BulletPoint[] = [
	{
		icon: iconSend,
		text: 'Ask supporters to share with friends',
	},
	{
		icon: iconGroups,
		text: 'Ask supporters to contact decision maker',
	},
	{
		icon: iconCampaign,
		text: 'Celebrate petition news and milestones',
	},
];
